export type StageStatus = "completed" | "current" | "upcoming";

const ApplicationStageMarker = ({ status }: { status: StageStatus }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    {status === "upcoming" ? (
      <circle cx="8" cy="8" r="7" fill="none" stroke="#ccd4d1" strokeWidth="1" />
    ) : (
      <circle cx="8" cy="8" r="7.5" fill="#047957" />
    )}
    {status === "completed" && (
      <path
        d="M4.9 8.2 L7 10.4 L11.2 6.1"
        fill="none"
        stroke="#ffffff"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

export default ApplicationStageMarker;
